import {
  CONTACT_BOOKING_FAILED,
  CONTACT_BOOKING_REQ,
  CONTACT_BOOKING_SUCCESS,
  TEST_BOOKING_FAILED,
  TEST_BOOKING_REQ,
  TEST_BOOKING_SUCCESS,
} from "../Constant/ContactConstant";
import api from "../Core/api";

export const Contact_Us = (ContactDet) => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_BOOKING_REQ });
    const { data } = await api.post("/contactus", ContactDet);
    dispatch({ type: CONTACT_BOOKING_SUCCESS, payload: data?.Result });
  } catch (error) {
    dispatch({
      type: CONTACT_BOOKING_FAILED,
      payload:
        error.response && error?.response?.data?.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const Test_Book = (Details, apidata) => async (dispatch) => {
  try {
    dispatch({ type: TEST_BOOKING_REQ });
    const { data } = await api.post(
      apidata ? apidata : "/landing/contact",
      Details
    );
    dispatch({ type: TEST_BOOKING_SUCCESS, payload: data?.Result,score:data?.Score });
  } catch (error) {
    dispatch({
      type: TEST_BOOKING_FAILED,
      payload:
        error.response && error?.response?.data?.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
